import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M10.4289 4.42857V1L6.14321 5.28571L10.4289 9.57143V6.14286C13.2661 6.14286 15.5718 8.44857 15.5718 11.2857C15.5718 14.1229 13.2661 16.4286 10.4289 16.4286C7.59178 16.4286 5.28606 14.1229 5.28606 11.2857H3.57178C3.57178 15.0743 6.64035 18.1429 10.4289 18.1429C14.2175 18.1429 17.2861 15.0743 17.2861 11.2857C17.2861 7.49714 14.2175 4.42857 10.4289 4.42857Z" fill="#00011B"/>
</svg>
;
